export enum CommentRole {
    ASSISTANT = 'ASSISTANT',
    SYSTEM = 'SYSTEM',
    USER = 'USER',
}

export interface LLMError {
    code: number;
    message: string;
    details: string;
}

export interface Comment {
    role: CommentRole;
    content: string;
    timestamp: string;
}

export interface ConversationHistory {
    eventSequenceId: number;
    includeESD: boolean;
    comments: Comment[];
    llm: string;
    queryTime: string;
    error: LLMError;
}